var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-layout form px-0" },
    [
      _c("filter-budget-advanced", {
        attrs: {
          "show-user-selector": false,
          "label-expense-details": _vm.FormMSG(148, "Expense details"),
          "use-department-for-expense": "",
          "hide-process-filter": false,
          "filter-type": _vm.FILTER_TYPE.BUDGET_EXPENSES,
          "hide-co-two-detail": "",
          "hide-flag-filter": false,
        },
        on: {
          "filter-budget-advanced:click-selection":
            _vm.handleFilterBudgetAdvancedClickSelection,
        },
      }),
      _c(
        "div",
        { staticClass: "row mt-3 hide-on-tablet" },
        [
          _c(
            "b-col",
            { attrs: { md: "5" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0" },
                [
                  _vm.$screen.width >= 992
                    ? _c(
                        "b-input-group",
                        [
                          _c("filterInputSearch", {
                            attrs: { id: "expense-search-id" },
                            on: {
                              "filtered-users": _vm.activeFilter,
                              "handle-init-filter": _vm.onHandleInitFilter,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "7" } },
            [
              !_vm.haveActiveFilter
                ? _c("custom-pagination", {
                    attrs: {
                      "total-records": _vm.totalRecords,
                      "initial-perpage": _vm.perPage,
                      "initial-offset": _vm.offset,
                      "initial-limit": _vm.limit,
                      "filter-type": _vm.FILTER_TYPE.BUDGET_EXPENSES,
                    },
                    on: {
                      "custom-pagination:previous": _vm.handleClickLoadMore,
                      "custom-pagination:forward": _vm.handleClickLoadMore,
                      "custom-pagination:change-per-page":
                        _vm.handleClickLoadMore,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row mt-3 ml-1" },
        [
          !_vm.$screen.md
            ? _c("CardListBuilder", {
                staticClass: "hide-on-desktop",
                staticStyle: { width: "100%" },
                attrs: {
                  items: _vm.expenseItems,
                  filter: _vm.filter,
                  fields: _vm.bgFieldsMobile,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "actions",
                      fn: function (data) {
                        return [
                          _c("div", { staticClass: "mt-2" }, [
                            _c(
                              "div",
                              {
                                staticClass: "edit",
                                attrs: { role: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openEditExpense(data.item)
                                  },
                                },
                              },
                              [_c("edit")],
                              1
                            ),
                            _vm._v("\n\t\t\t\t\t \n\t\t\t\t\t"),
                            data.item.images.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "pic",
                                    attrs: { role: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showPicture(data.item.images)
                                      },
                                    },
                                  },
                                  [_c("photo")],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  995012649
                ),
              })
            : _c("b-table", {
                staticStyle: { width: "100%", "font-weight": "500" },
                attrs: {
                  responsive: "sm",
                  filter: _vm.filter,
                  items: _vm.expenseItems,
                  fields: _vm.bgFields,
                  "sticky-header": "700px",
                  "head-variant": _vm.hv,
                  hover: true,
                  bordered: "",
                  small: "",
                  "show-empty": "",
                  selectable: "",
                  selectedVariant: _vm.selectedColor,
                  "select-mode": _vm.selectMode,
                  "empty-text": _vm.FormMSG(265, "No budget expenses found"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(processed)",
                    fn: function ({ item, index }) {
                      return [
                        _c(
                          "div",
                          [
                            _c("b-form-checkbox", {
                              attrs: {
                                disabled: !_vm.canMarkEntryAsProcessed,
                                size: "lg",
                                value: true,
                                "unchecked-value": false,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleChangeProcess(
                                    $event,
                                    item,
                                    index
                                  )
                                },
                              },
                              model: {
                                value: item.processed,
                                callback: function ($$v) {
                                  _vm.$set(item, "processed", $$v)
                                },
                                expression: "item.processed",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(validated)",
                    fn: function (data) {
                      return [
                        _c("div", { staticClass: "wrap-status" }, [
                          _c(
                            "div",
                            {
                              class: `status ${data.item.statusClass}`,
                              staticStyle: { "font-size": "0.7rem" },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(data.item.validatedStatus) +
                                  "\n\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(userDepartmentName)",
                    fn: function (data) {
                      return [
                        _c("div", { staticClass: "text-left" }, [
                          _c("div", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  data.item.userDepartmentName
                                    .charAt(0)
                                    .toUpperCase() +
                                    data.item.userDepartmentName
                                      .slice(1)
                                      .toLowerCase()
                                ) +
                                " -\n\t\t\t\t\t\t" +
                                _vm._s(
                                  data.item.functionName
                                    .charAt(0)
                                    .toUpperCase() +
                                    data.item.functionName
                                      .slice(1)
                                      .toLowerCase()
                                ) +
                                "\n\t\t\t\t\t"
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(option)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-dropdown",
                          {
                            attrs: {
                              "no-caret": "",
                              dropleft: "",
                              offset: "25",
                              variant: "none",
                              size: "sm",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button-content",
                                  fn: function () {
                                    return [
                                      _c("more-vertical", {
                                        attrs: { size: 16 },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openEditExpense(data.item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-color-rhapsody-in-blue d-flex align-items-center",
                                  },
                                  [
                                    _c(_vm.getLucideIcon("Edit"), {
                                      tag: "component",
                                      attrs: { size: 16 },
                                    }),
                                    _c("div", { staticClass: "ml-2" }, [
                                      _vm._v(_vm._s(_vm.FormMSG(1000, "Edit"))),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm.canDeleteExpensesOrPO
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDeleteWarning(data.item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-danger d-flex align-items-center",
                                      },
                                      [
                                        _c(_vm.getLucideIcon("Trash"), {
                                          tag: "component",
                                          attrs: { size: 16 },
                                        }),
                                        _c("div", { staticClass: "ml-2" }, [
                                          _vm._v(
                                            _vm._s(_vm.FormMSG(1002, "Delete"))
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
        ],
        1
      ),
      _c("expense-carousel-view-modal", {
        ref: "expense-carousel-view-modal",
        attrs: {
          "reload-data-after-img-inserted": false,
          expense: _vm.currentExpense,
          "expense-item": {
            index: 0,
            data: _vm.currentExpenseItem,
          },
          "expense-items": [_vm.currentExpenseItem],
          "can-only-make-split-item": "",
        },
        on: {
          "expense-carousel-view-modal:closed": _vm.onExpenseCarouselViewClosed,
          "expense-carousel-view-modal:reload":
            _vm.onExpenseCarouselViewReloaded,
        },
        model: {
          value: _vm.isNewExpenseModalOpen,
          callback: function ($$v) {
            _vm.isNewExpenseModalOpen = $$v
          },
          expression: "isNewExpenseModalOpen",
        },
      }),
      _c("script-export-modal", {
        attrs: {
          items: _vm.scripts,
          custom: _vm.customReport,
          "export-type": "expenseitem",
        },
        on: {
          "script-export-modal:loading": _vm.handleLoading,
          "script-export-modal:closed": _vm.expenseRerpotOnClosed,
        },
        model: {
          value: _vm.isScriptExpenseReportOpen,
          callback: function ($$v) {
            _vm.isScriptExpenseReportOpen = $$v
          },
          expression: "isScriptExpenseReportOpen",
        },
      }),
      _c("common-warning-on-delete", {
        attrs: { message: _vm.messageOnDeleteExpense },
        on: {
          "dialog:cancel": _vm.closeDeleteWarning,
          "dialog:confirm": _vm.deleteExpenseItem,
        },
        model: {
          value: _vm.showDeleteWarning,
          callback: function ($$v) {
            _vm.showDeleteWarning = $$v
          },
          expression: "showDeleteWarning",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }